import { useFragment } from '@apollo/client';
import { plural, t } from '@lingui/core/macro';
import { Box, Chip, ListItem, TeamAvatar } from '@pocketlaw/tetris';
import { getAccessLevelName } from 'app/domains/filesystem/components/AccessManagement/getAccessLevelName';
import { AclAction } from 'shared/domains/apollo/generated/types';
import { DocumentTeamAccessListFragmentDoc } from './DocumentTeamAccessList.gql';
export function DocumentTeamAccessList(props) {
    const { from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: DocumentTeamAccessListFragmentDoc,
        fragmentName: 'DocumentTeamAccessList',
    });
    if (!complete) {
        return null;
    }
    const getSubtitle = (count = 0) => t({
        message: plural(count, {
            one: '# member',
            other: '# members',
        }),
        comment: 'Document team access list - subtitle',
    });
    const teamAcls = data.teamAcls.filter((acl) => !acl.actions.includes(AclAction.Traverse) && !acl.team.isProjectTeam);
    return teamAcls.map((acl) => {
        var _a, _b;
        return (<ListItem disabled key={acl.id}>
      <TeamAvatar title={((_a = acl.team) === null || _a === void 0 ? void 0 : _a.name) || ''} subtitle={getSubtitle((_b = acl.team) === null || _b === void 0 ? void 0 : _b.members.length)} size="md"/>
      <Box ml="auto">
        <Chip label={getAccessLevelName(acl.actions)} appearance="secondary" variant="outline" size="small"/>
      </Box>
    </ListItem>);
    });
}
